export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

export const insideItems: string[] = [
  'Workplace hazard identification diagrams',
  'Risk assessment training concepts',
  'Hierarchy of controls illustrations',
  'Factory hazard recognition scenarios',
  'Industrial workplace maps',
  'Warehouse traffic illustrations',
  'Forklift-pedestrian interaction examples',
  'Loading-area hazard awareness',
  'Material handling safety concepts',
  'Mechanical hazard classification',
  'Machine component anatomy',
  'Industrial gear illustrations',
  'Rotating shaft diagrams',
  'Conveyor belt systems',
  'Roller conveyor comparisons',
  'Machinery guarding examples',
  'Hydraulic system diagrams',
  'Pneumatic energy illustrations',
  'Electrical hazard awareness',
  'Stored-energy classification',
  'Lockout/tagout awareness concepts',
  'Fire prevention examples',
  'Emergency preparedness diagrams',
  'Working-at-height scenarios',
  'Ladder hazard recognition',
  'PPE identification resources',
  'Chemical hazard awareness',
  'Ergonomic risk examples',
  'Occupational health concepts',
  'Correct-versus-incorrect comparisons',
  'Before-and-after workplace improvements',
  'Hazard-identification challenges',
  'Instructor classroom activities',
  'Knowledge assessments',
  'Quick-reference field cards',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/jYTPpRvnz3MgmadmbcouDB/Captura_de_pantalla_2026-10-21_212803.png',
    alt: 'The Industrial Machinery Safety Map: factory floor divided into eight numbered hazard-training zones',
    title: 'Industrial Machinery Safety Map',
    caption: 'See how a complete factory is divided into recognizable hazard-training zones.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7G6Tqr1ETmagJHB3BpZ2hF/Captura_de_pantalla_2026-10-21_212828.png',
    alt: 'Roller conveyor hazards training sheet comparing powered and non-powered conveyors with roller gaps and transfer zones',
    title: 'Roller Conveyor Hazards',
    caption:
      'Understand machinery movement, roller hazards and workplace exposure through detailed technical illustrations.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vaZJeDxje2sFhAxHWbZ6A4/Captura_de_pantalla_2026-10-21_212654.png',
    alt: 'Factory hazard identification student version with ten observation markers placed across an industrial scene',
    title: 'Factory Hazard Identification',
    caption:
      'Challenge students to observe a realistic industrial environment and identify potential hazards.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6tfWeW3VEyHQs3RPMEsb3a/Captura_de_pantalla_2026-10-21_212617.png',
    alt: 'Fixed guards versus exposed components: three before-and-after guarding comparisons for belts, shafts and gears',
    title: 'Fixed Guards vs. Exposed Components',
    caption: 'Show the difference between exposed machinery and improved guarding arrangements.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/stTgvEWGNDMj3cT45qM3Uf/Captura_de_pantalla_2026-10-21_212541.png',
    alt: 'Industrial gears and transmissions training sheet showing meshing zones and guarding concepts',
    title: 'Industrial Gears & Transmissions',
    caption: 'Explore moving mechanical components through professional industrial diagrams.',
  },
]
